import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import Modal from "react-responsive-modal"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Redirect } from "react-router-dom"
import { Formik, Field, Form } from "formik"
import NumberField from "components/NumberField"
import fields from "models/community"
import usStates from 'models/usStates'
import * as Yup from "yup"
import TextArea from "components/TextArea"

import DateField from "components/DateField"
import _ from 'lodash'
import Title from "../general/title"
import settings from "settings"
import ReactSelect from "components/ReactSelect"
import { toast } from "react-toastify"

class AddCommunity extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ready: false,
            modal: false,
            fields: fields,
        }
    }

    validation = () => {
        return Yup.object().shape({
            name: Yup.string().required("Required"),
            startDate: Yup.number().required("Required"),
            state: Yup.string().required("Required")
		})
    }

    submitClasses = f => {
        var classNames = require("classnames")
        var submitClasses = classNames("form__submit", {
            "form__submit--ready": f,
        })

        return submitClasses
    }

    transformStates = () => {
        let opts = []
        _.forEach(usStates, (v, k) => {
            opts.push({ label: v, value: k })
        })
        return opts
    }

    transformMetro = () => {
        let opts = []
        _.forEach(this.props.payload.public.metro, v => {
            opts.push({ label: v.name, value: v.id })
        })
        return opts
    }

    transformDevelopers = () => {
        let opts = []
        _.forEach(this.props.payload.public.developers, v => {
            opts.push({ label: v.name, value: v.id })
        })
        return opts
	}
	
	options = name => {
		let opts = []
		_.forEach(this.props.payload.public[name], v => {
			opts.push({ label: v.name, value: v.id })
		})
		return opts
	}

    render() {
        if (!this.props.payloadStatus) {
			return ""
		} else if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			const { open } = this.props
			let property = _.find(this.props.payload.properties, {
				id: this.state.fields.property,
			})
			let sec = _.find(this.props.payload.public.sections, { id: this.state.fields.section_id })
			let states = this.transformStates()
			let metro = this.transformMetro()
			let developers = this.transformDevelopers()
			return (
				<div>
					<Title title="Add Community" showDate={false} />
					<div className="content">
						<h3 />
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							validateOnMount={true}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								submitData("addCommunity", values).then((data) => {
									this.props.loadingStatus(false)
									toast.success(data.message)
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}
							render={(f) => (
								<div className="addCommunity">
									{/* console.log(f) */}
									<Form>
										<ul className="form__list">
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("url", f)}>
												<label htmlFor="url">URL</label>
												{f.errors.url && f.touched.url && (
													<div className="form__message">{f.errors.url}</div>
												)}
												<Field name="url" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("startDate", f)}>
												<label htmlFor="startDate">
													Start Date <sup>*</sup>
												</label>
												{f.errors.startDate && f.touched.startDate && (
													<div className="form__message">{f.errors.startDate}</div>
												)}
												<DateField
													name="startDate"
													className="form__textarea"
													value={f.values.startDate}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.startDate}
													error={f.errors.startDate}
												/>
											</li>
											<li className={fieldStatus("logo", f)}>
												<label htmlFor="logo">Logo</label>
												{f.errors.logo && f.touched.logo && (
													<div className="form__message">{f.errors.logo}</div>
												)}
												<Field name="logo" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("city", f)}>
												<label htmlFor="city">
													City
												</label>
												{f.errors.city && f.touched.city && (
													<div className="form__message">{f.errors.city}</div>
												)}
												<Field name="city" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("zip", f)}>
												<label htmlFor="zip">Zip</label>
												{f.errors.zip && f.touched.zip && (
													<div className="form__message">{f.errors.zip}</div>
												)}
												<Field name="zip" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("state", f)}>
												<label htmlFor="state">
													State <sup>*</sup>
												</label>
												{f.errors.state && f.touched.state && (
													<div className="form__message">{f.errors.state}</div>
												)}
												<ReactSelect
													name={`state`}
													options={states}
													value={f.values.state}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("metro_group", f)}>
												<label htmlFor="metro_group">Metro Group</label>
												{f.errors.metro_group && f.touched.metro_group && (
													<div className="form__message">{f.errors.metro_group}</div>
												)}
												<ReactSelect
													name={`metro_group`}
													options={metro}
													value={f.values.metro_group}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("metro_sub_group", f)}>
												<label htmlFor="metro_sub_group">Metro Sub Group</label>
												{f.errors.metro_sub_group && f.touched.metro_sub_group && (
													<div className="form__message">{f.errors.metro_sub_group}</div>
												)}
												<ReactSelect
													name={`metro_sub_group`}
													options={this.options("metroSub")}
													value={f.values.metro_sub_group}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("developers", f)}>
												<label htmlFor="developers">Developers</label>
												{f.errors.developers && f.touched.developers && (
													<div className="form__message">{f.errors.developers}</div>
												)}
												<ReactSelect
													name={`developers`}
													options={developers}
													isMulti
													value={f.values.developers}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("finance_name", f)}>
												<label htmlFor="finance_name">Finance Name</label>
												{f.errors.finance_name && f.touched.finance_name && (
													<div className="form__message">{f.errors.finance_name}</div>
												)}
												<Field name="finance_name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("finance_address", f)}>
												<label htmlFor="finance_address">Finance Address</label>
												{f.errors.finance_address && f.touched.finance_address && (
													<div className="form__message">{f.errors.finance_address}</div>
												)}
												<Field name="finance_address" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("finance_city", f)}>
												<label htmlFor="finance_city">Finance City</label>
												{f.errors.finance_city && f.touched.finance_city && (
													<div className="form__message">{f.errors.finance_city}</div>
												)}
												<Field name="finance_city" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("finance_state", f)}>
												<label htmlFor="finance_state">Finance State</label>
												{f.errors.finance_state && f.touched.finance_state && (
													<div className="form__message">{f.errors.finance_state}</div>
												)}
												<ReactSelect
													name="finance_state"
													options={this.props.payload.public.states}
													className="form__input"
													value={f.values.finance_state}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.finance_state}
													error={f.errors.finance_state}
												/>
											</li>
											<li className={fieldStatus("finance_zip", f)}>
												<label htmlFor="finance_zip">Finance Zip</label>
												{f.errors.finance_zip && f.touched.finance_zip && (
													<div className="form__message">{f.errors.finance_zip}</div>
												)}
												<Field name="finance_zip" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("finance_phone", f)}>
												<label htmlFor="finance_phone">Finance Phone</label>
												{f.errors.finance_phone && f.touched.finance_phone && (
													<div className="form__message">{f.errors.finance_phone}</div>
												)}
												<NumberField
													name={`finance_phone`}
													value={f.values.finance_phone}
													format="+1 (###) ###-####"
													className="form__input"
													isNumericString
													onChange={(name, v) => {
														f.setFieldValue(`finance_phone`, v)
													}}
													onBlur={() => f.setFieldTouched("finance_phone", true)}
												/>
											</li>
											<li className={fieldStatus("finance_email", f)}>
												<label htmlFor="finance_email">Finance Email</label>
												{f.errors.finance_email && f.touched.finance_email && (
													<div className="form__message">{f.errors.finance_email}</div>
												)}
												<Field name="finance_email" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("funds_hoa", f)}>
												<label htmlFor="funds_hoa">Funds HOA</label>
												{f.errors.funds_hoa && f.touched.funds_hoa && (
													<div className="form__message">{f.errors.funds_hoa}</div>
												)}
												<TextArea
													name="funds_hoa"
													className="form__textarea"
													value={f.values.funds_hoa}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.funds_hoa}
													error={f.errors.funds_hoa}
												/>
											</li>
											<li className={fieldStatus("funds_development", f)}>
												<label htmlFor="funds_development">Funds Development</label>
												{f.errors.funds_development && f.touched.funds_development && (
													<div className="form__message">{f.errors.funds_development}</div>
												)}
												<TextArea
													name="funds_development"
													className="form__textarea"
													value={f.values.funds_development}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.funds_development}
													error={f.errors.funds_development}
												/>
											</li>
											<li className={fieldStatus("funds_partnership", f)}>
												<label htmlFor="funds_partnership">Funds Partnership</label>
												{f.errors.funds_partnership && f.touched.funds_partnership && (
													<div className="form__message">{f.errors.funds_partnership}</div>
												)}
												<TextArea
													name="funds_partnership"
													className="form__textarea"
													value={f.values.funds_partnership}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.funds_partnership}
													error={f.errors.funds_partnership}
												/>
											</li>
											<li className={fieldStatus("funds_lien", f)}>
												<label htmlFor="funds_lien">Funds First Lien</label>
												{f.errors.funds_lien && f.touched.funds_lien && (
													<div className="form__message">{f.errors.funds_lien}</div>
												)}
												<TextArea
													name="funds_lien"
													className="form__textarea"
													value={f.values.funds_lien}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.funds_lien}
													error={f.errors.funds_lien}
												/>
											</li>
											{settings.enabled.zonda && (
												<li className={fieldStatus("competitors", f)}>
													<label htmlFor="competitors">Competitors</label>
													{f.errors.competitors && f.touched.competitors && (
														<div className="form__message">{f.errors.competitors}</div>
													)}
													<ReactSelect
														name={`competitors`}
														options={_.map(
															this.props.payload.public.zonda?.communities,
															(v) => {
																return { value: v.id, label: v.name }
															}
														)}
														isMulti
														value={f.values.competitors}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
											)}
											<li className={fieldStatus("builders", f, false, false, true)}>
												<label htmlFor="builders">Builders</label>
												{f.errors.builders && f.touched.builders && (
													<div className="form__message">{f.errors.builders}</div>
												)}
												<ReactSelect
													name={`builders`}
													options={_.map(this.props.payload.public.builders, (v) => {
														return {
															label: v.name,
															value: v.id,
														}
													})}
													value={f.values.builders}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
													isMulti
												/>
											</li>
											<li className={fieldStatus("notify_emails", f)}>
												<label htmlFor="notify_emails">Builder Admins</label>
												<p className="small">(Receives notifications)</p>
												{f.errors.notify_emails && f.touched.notify_emails && (
													<div className="form__message">{f.errors.notify_emails}</div>
												)}
												<TextArea
													name="notify_emails"
													className="form__textarea"
													value={f.values.notify_emails}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.notify_emails}
													error={f.errors.notify_emails}
												/>
											</li>
											<li className={fieldStatus("community_admins", f)}>
												<label htmlFor="community_admins">Community Admins</label>
												<p className="small">(Receives notifications)</p>
												{f.errors.community_admins && f.touched.community_admins && (
													<div className="form__message">{f.errors.community_admins}</div>
												)}
												<TextArea
													name="community_admins"
													className="form__textarea"
													value={f.values.community_admins}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.community_admins}
													error={f.errors.community_admins}
												/>
											</li>
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						/>
					</div>
				</div>
			)
		}
    }
}

function mapStateToProps(state) {
    return {
        payload: state.payload,
        payloadStatus: state.payloadStatus
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
			loadingStatus,
			getPayload
        },
        dispatch
    )
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(AddCommunity)
